export default function EditIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V8.25H14.25V14.25H3.75V3.75H9.75V2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75ZM14.4 2.69998L15.3 3.59999C15.9 4.12499 15.9 5.09998 15.3 5.69998L8.25 12.75H5.25V9.75L12.3 2.69998C12.6 2.39998 12.975 2.25 13.35 2.25C13.725 2.25 14.1 2.39998 14.4 2.69998ZM6.75 11.25H7.65L14.25 4.65001L13.35 3.75L6.75 10.35V11.25Z"
        fill="#544F4F"
      />
    </svg>
  );
}
